module.exports = __webpack_public_path__ + "static/media/brakes.1ca47591.svg";